/**
 * The view session id (`vs`): one per video page load, sent on the HLS
 * master URL (the server carries it to every variant and segment, and on to
 * the CDN as `vid_session`) and on every listen-video beacon. It replaces the
 * Laravel session cookie as the view grain, because that cookie does not
 * survive in a cross-site iframe. Must match the server's ViewSession format.
 */
export const VIEW_SESSION_PATTERN = /^[A-Za-z0-9-]{8,64}$/

export function createViewSessionId(cryptoImpl = globalThis.crypto) {
    if (typeof cryptoImpl?.randomUUID === "function") {
        return cryptoImpl.randomUUID()
    }

    const bytes = new Uint8Array(16)

    if (typeof cryptoImpl?.getRandomValues === "function") {
        cryptoImpl.getRandomValues(bytes)
    } else {
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = Math.floor(Math.random() * 256)
        }
    }

    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")
}
